import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccountLookupService } from '../../services/AccountLookupService';
import { fetchAccountsLookupActionName } from './actionTypes';

export const fetchAccountsLookupAction = createAsyncThunk(fetchAccountsLookupActionName, async () => {
  return AccountLookupService.getAccountsLookup();
});
